import * as actions from './tailoringCollection/actions'
import * as mutations from './tailoringCollection/mutations'
import * as getters from './tailoringCollection/getters'

import { dataProps } from './tailoringCollection/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringCollection.js